import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import * as RadixToast from '@radix-ui/react-toast';
import Toast from '../components/ui/Toast';
import { $app } from './App';

const DURATION = 4200;

const ToastContext = createContext(() => {});

export const useToast = () => useContext(ToastContext);

const normalize = (content) =>
  content && typeof content === 'object' && !content.type ? content : { description: content };

const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  const [open, setOpen] = useState(false);

  const show = useCallback((content, type = 'success') => {
    setToast({ ...normalize(content), type, key: Date.now() });
    setOpen(true);
  }, []);


  useEffect(() => {
    $app.setMessageApi({ open: ({ content, type }) => show(content, type) });
  }, [show]);

  return (
    <ToastContext.Provider value={show}>
      <RadixToast.Provider swipeDirection="up" duration={DURATION}>
        {children}

        {toast && (
          <Toast
            key={toast.key}
            title={toast.title}
            description={toast.description}
            type={toast.type}
            open={open}
            onOpenChange={setOpen}
          />
        )}

        <RadixToast.Viewport className="toast-viewport" />
      </RadixToast.Provider>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
